import { render, staticRenderFns } from "./Filechooser.vue?vue&type=template&id=4c626fac&scoped=true"
import script from "./Filechooser.vue?vue&type=script&lang=js"
export * from "./Filechooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c626fac",
  null
  
)

export default component.exports